import api from "@/plugins/axios";

export const getAllByEmpresa = async (id) => {
  const response = await api.get(`/usuario/byEmpresa/${id}`);
  return response.data;
};

export const getAll = async () => {
  const response = await api.get("/usuario");
  return response.data;
};

export const getById = async (id) => {
  const response = await api.get(`/usuario/${id}`);
  return response.data;
};

export const create = async (data) => {
  const response = await api.post("/usuario", data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await api.put(`/usuario/${id}`, data);
  return response.data;
};

export const remove = async (id) => {
  await api.delete(`/usuario/${id}`);
};
